(() => {
  if (window.BarkBeltFeraReviews) {
    window.BarkBeltFeraReviews.mount();
    return;
  }

  const SECTION_SELECTOR = '[data-bb-fera-reviews][data-bb-fera-integration="automatic"]';
  const MOUNT_SELECTOR = '[data-bb-fera-reviews-mount]';
  const WIDGET_SELECTOR = '.fera-productReviews-widget:not([data-fera-container])';
  let sectionIsUnloading = false;

  function getAutomaticWidget() {
    const widgets = Array.from(document.querySelectorAll(WIDGET_SELECTOR));
    return widgets.find((widget) => !widget.closest(MOUNT_SELECTOR) && widget.id === 'reviews')
      || widgets.find((widget) => !widget.closest(MOUNT_SELECTOR));
  }

  function mount() {
    if (sectionIsUnloading) return false;

    const section = document.querySelector(SECTION_SELECTOR);
    const target = section?.querySelector(MOUNT_SELECTOR);
    if (!target) return false;

    const mountedWidget = target.querySelector(WIDGET_SELECTOR);
    if (mountedWidget) {
      section.dataset.bbFeraReady = 'true';
      return true;
    }

    const automaticWidget = getAutomaticWidget();
    if (!automaticWidget) return false;

    target.appendChild(automaticWidget);
    section.dataset.bbFeraReady = 'true';
    return true;
  }

  const observer = new MutationObserver(() => mount());

  function start() {
    mount();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:unload', (event) => {
    const widget = event.target.querySelector(`${MOUNT_SELECTOR} ${WIDGET_SELECTOR}`);
    const content = document.querySelector('main#content');
    if (!widget || !content) return;

    sectionIsUnloading = true;
    content.appendChild(widget);
    window.setTimeout(() => {
      sectionIsUnloading = false;
      mount();
    }, 0);
  });

  document.addEventListener('shopify:section:load', () => mount());

  window.BarkBeltFeraReviews = { mount };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
